
import isEmpty from 'lodash/isEmpty'

import HighlightedProductCard from '@recommendation/components/HighlightedProductCard/HighlightedProductCard.vue'

import productCardTranslations from '../ProductCard.translations'
import ProductCard from '../ProductCard.vue'
import ProductCardWithAttributes from '../ProductCardWithAttributes.vue'
import ViewportTracking from '../ViewportTracking.vue'

import ProductAd from './ProductAd'

export default {
  components: {
    ProductCard,
    ProductAd,
    ProductCardWithAttributes,
    HighlightedProductCard,
    ViewportTracking,
  },
  props: {
    highlightedProduct: {
      type: Object,
      default: undefined,
    },
    searchResults: {
      type: Array,
      required: true,
    },
    wide: {
      type: Boolean,
      default: false,
    },
    showAdvert: {
      type: Boolean,
      default: false,
    },
    showBuyingGuide: {
      type: Boolean,
      default: false,
    },
    showPaymentMethodAdvertising: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    productCardTranslations: () => productCardTranslations,
    totalResultDisplayed() {
      return this.highlightedProduct
        ? 1 + this.searchResults.length
        : this.searchResults.length
    },
    advertClassNames() {
      return {
        'row-start-4 col-span-full': this.wide && this.totalResultDisplayed > 2,
        'row-start-6 md:row-start-3 md:col-start-2 lg:row-start-2 lg:col-start-3':
          !this.wide && this.totalResultDisplayed > 4,
      }
    },
    advertPosition() {
      if (this.wide && this.totalResultDisplayed > 2) {
        return 4
      }
      if (!this.wide && this.totalResultDisplayed > 4) {
        return 6
      }

      return this.totalResultDisplayed + 1
    },
    buyingGuideClassNames() {
      return this.buyingGuidePaymentMethodAdClassNames(this.showAdvert)
    },
    paymentMethodAdClassNames() {
      const hasReadyAnotherAd = this.showAdvert || this.showBuyingGuide

      return this.buyingGuidePaymentMethodAdClassNames(hasReadyAnotherAd)
    },
    shouldDisplayHighlightedProduct() {
      return !isEmpty(this.highlightedProduct)
    },
  },
  methods: {
    buyingGuidePaymentMethodAdClassNames(hasReadyAnotherAd) {
      if (hasReadyAnotherAd) {
        return this.wide
          ? 'row-start-[8] col-span-full'
          : 'row-start-[12] md:row-start-6 md:col-start-2 lg:row-start-4 lg:col-start-3'
      }

      return this.wide
        ? 'row-start-4 col-span-full'
        : 'row-start-6 md:row-start-3 md:col-start-2 lg:row-start-2 lg:col-start-3'
    },
  },
}
